import React, { FC, ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, ThemeSync, ServiceMigration, ProjectInit, StoragePersistenceInit, AuthInit } from '../stores';
import { PersistenceWarningBanner } from '../shared/ui/PersistenceWarningBanner';
import { ErrorBoundary } from './ErrorBoundary';

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: FC<AppProviderProps> = ({ children }) => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeSync />
        <ServiceMigration />
        <ProjectInit />
        <AuthInit />
        <StoragePersistenceInit />
        <PersistenceWarningBanner />
        {children}
        <ToastContainer />
      </BrowserRouter>
    </ErrorBoundary>
  );
};